import { IconTypeProps } from '../shared/types/types';

export function FilterOutlined({
  width = '24',
  height = '24',
  color = 'currentColor',
}: IconTypeProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9975 24C12.7812 24 12.5706 23.9298 12.3975 23.8L8.39754 20.8C8.27334 20.7068 8.17254 20.5861 8.10311 20.4472C8.03368 20.3084 7.99754 20.1552 7.99754 20V14.38L0.981539 6.487C0.483259 5.92488 0.157918 5.23081 0.0446191 4.48823C-0.0686803 3.74565 0.0348833 2.98615 0.342862 2.30101C0.650841 1.61588 1.15013 1.03426 1.78072 0.626066C2.41131 0.217873 3.14636 0.000474419 3.89754 0L18.0975 0C18.8486 0.000881051 19.5835 0.218639 20.2139 0.627107C20.8442 1.03557 21.3432 1.61737 21.6508 2.30258C21.9585 2.9878 22.0617 3.74727 21.9481 4.48975C21.8345 5.23222 21.509 5.9261 21.0105 6.488L13.9975 14.38V23C13.9975 23.2652 13.8922 23.5196 13.7046 23.7071C13.5171 23.8946 13.2628 24 12.9975 24ZM9.99754 19.5L11.9975 21V14C11.9977 13.7552 12.0878 13.5189 12.2505 13.336L19.5185 5.159C19.7609 4.88508 19.919 4.54704 19.974 4.18545C20.0289 3.82386 19.9783 3.4541 19.8283 3.12056C19.6783 2.78701 19.4351 2.50386 19.1281 2.30509C18.8211 2.10632 18.4633 2.00038 18.0975 2H3.89754C3.53199 2.00055 3.17436 2.10655 2.86754 2.30527C2.56072 2.50398 2.31775 2.78699 2.16775 3.12035C2.01775 3.45371 1.96709 3.82326 2.02187 4.18468C2.07664 4.5461 2.23451 4.88405 2.47654 5.158L9.74554 13.336C9.90795 13.519 9.99761 13.7553 9.99754 14V19.5Z"
        fill={color}
      />
    </svg>
  );
}
